<template>
  <!-- predlozi tezgi za pracenje na pocetnoj: logika klizaca je u ScrollSlider -->
  <ScrollSlider
    :items="suggestionsList"
    :title="title"
    item-class="swiper-product-width-follow"
    :btn-prev-class="['swiper-button-prev-tc-most', btn_prev]"
    :btn-next-class="['swiper-button-next-tc-most', btn_next]"
    icon-class="font-icon-module"
    :dots-class="['mt-4 swiper-pagination-most', paginate]"
  >
    <template #item="{ item }">
      <FollowCard :customer="item" />
    </template>
  </ScrollSlider>
</template>

<script setup>
import ScrollSlider from '~/components/widgets/Slider/ScrollSlider.vue'
import FollowCard from './FollowCard.vue'

const props = defineProps({
  suggestions: { type: Array, default: () => [] },
  title: { type: String, default: 'Kupite na tezgama' },

  paginate: { type: String, default: 'swiper-pagination' },
  btn_next: { type: String, default: 'swiper-button-next' },
  btn_prev: { type: String, default: 'swiper-button-prev' },
})

const suggestionsList = computed(() => (Array.isArray(props.suggestions) ? props.suggestions : []))
</script>
